import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../contexts/SessionContext';
import API_URL from '../constants/environment';

interface LatestDownloadInput {
    legacy: boolean;
}

interface LatestDownloadResponse {
    version: string;
    downloadUrl: string;
    expiresInSeconds: number;
}

const getLatestDownload = async (
    input: LatestDownloadInput,
    sessionId: string | null,
): Promise<LatestDownloadResponse> => {
    const { data } = await axios.get<LatestDownloadResponse>(`${API_URL}/downloads/latest`, {
        headers: {
            Authorization: sessionId ?? '',
        },
        params: {
            legacy: input.legacy,
        },
    });
    return data;
};

export const useGetLatestDownload = () => {
    const sessionContext = useContext(SessionContext);

    return useMutation({
        mutationFn: (input: LatestDownloadInput) =>
            getLatestDownload(input, sessionContext?.sessionId ?? null),
    });
};
